/**
 * Profile icon for account/avatar display.
 */

import React from "react";
import type { IconProps } from "./types";

const ProfileIcon: React.FC<IconProps> = ({
  size = 24,
  color = "currentColor",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.198 12a5.03 5.03 0 002.666-.758 4.576 4.576 0 001.768-2.02 4.24 4.24 0 00.273-2.6 4.42 4.42 0 00-1.313-2.304 4.907 4.907 0 00-2.458-1.232 5.098 5.098 0 00-2.773.257A4.747 4.747 0 008.207 5a4.303 4.303 0 00-.81 2.5c.002 1.193.508 2.337 1.408 3.18.9.844 2.12 1.319 3.393 1.32zm0-7.5c.633 0 1.251.176 1.777.506.527.33.937.798 1.18 1.346.241.548.305 1.151.181 1.733a2.947 2.947 0 01-.876 1.536 3.271 3.271 0 01-1.638.821 3.399 3.399 0 01-1.849-.17 3.164 3.164 0 01-1.436-1.105 2.868 2.868 0 01-.54-1.667c0-.796.338-1.559.938-2.121a3.311 3.311 0 012.263-.879zM12.2 13.5c-1.909.002-3.739.714-5.089 1.98-1.35 1.265-2.109 2.98-2.111 4.77 0 .199.084.39.234.53.15.141.354.22.566.22a.828.828 0 00.566-.22.727.727 0 00.234-.53c0-1.392.59-2.728 1.64-3.712C9.29 15.553 10.715 15 12.2 15c1.485 0 2.91.553 3.96 1.538 1.05.984 1.64 2.32 1.64 3.712 0 .199.084.39.234.53.15.141.354.22.566.22a.828.828 0 00.566-.22.727.727 0 00.234-.53c-.002-1.79-.761-3.505-2.111-4.77-1.35-1.266-3.18-1.978-5.089-1.98z"
      fill={color}
    />
  </svg>
);

export default ProfileIcon;
